import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function WebsiteMaintenance() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>


        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Website <br />Maintenance</h1>
            <p style={{ marginBottom: '3.5rem' }}>At YGS Web Solutions, we know that every type of website is unique and that is why we work with all different sizes and website types according to our clients’ budgets and technical needs! We offer monthly maintenance packages that allow website owners the option to choose a package with a given number of hours that suits their website's needs for all kinds of backend management requirements. This means anywhere along the necessary lines of upgrading the backend infrastructure, optimizing the site for speed and performance, being up to date with the website’s security, optimizing all technologies, cloud platforms, third-party apps and integrations, database improvement and clearing malware.</p>
            <h3>Website Maintenance Service Packages</h3>
            <p style={{ marginBottom: '3.5rem' }}>With a maintenance plan, you are entitled to a block of time designated to solely your website by our expert team of web developers who will assess and address all the backend updates and clearing with a turnaround time of fewer than 24 hours. Our customers have access to us around the clock to bring up any sudden and emergency technical issues and be met with high-priority level assistance- which includes evenings, weekends, and even holidays! We follow up with monthly reports on the activities conducted for your records and digital safety assurance.</p>
            <h3>Typical types of website updates might include:</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Backend technical updates</li>
              <li>Bug fixes</li>
              <li>Software updates</li>
              <li>Version upgrades</li>
              <li>Plug-in technicalities</li>
              <li>Security updates for any payment gateways</li>
              <li>Troubleshooting issues and more..</li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>With regular and continual website maintenance, you can ensure that your website is running proficiently without any inconvenience to your customers or causing you any unwanted loss of sales.</p>
            <p style={{ marginBottom: '3.5rem' }}>We offer several package options, so you can choose the plan that best suits your requirements.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/7bb1819d552ff311c42b1f55be6dc0957213d226-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default WebsiteMaintenance